import './loader.css'
import Blur from "../blur/blur";
const Loader = () => {
    return (
        <div className="loader-container">
            <div className="lds-hourglass" />
        </div>
    )
}
export default Loader